export function CloudGlyph() {
  return (
    <svg width="72" height="56" viewBox="0 0 72 56" fill="none" aria-hidden="true">
      <path d="M17 36 C 8 36, 8 22, 18 22 C 20 13, 32 10, 37 18 C 46 14, 56 22, 54 30 C 62 30, 62 42, 54 42 L18 42 C 12 42, 12 36, 17 36 Z"
            stroke="#22c55e" strokeWidth="1.2" fill="none"/>
      {[0, 1, 2, 3, 4].map((i) => (
        <g key={i} transform={`translate(${24 + i * 5}, 48)`}>
          <rect width="2" height="4" fill="#22c55e" opacity={0.3 + i * 0.15} />
        </g>
      ))}
      <text x="36" y="32" textAnchor="middle" fontFamily="var(--p2a-font-mono)" fontSize="8" fill="#22c55e" letterSpacing="1">GCP</text>
    </svg>
  );
}

export function BrowserGlyph() {
  return (
    <svg width="96" height="60" viewBox="0 0 96 60" fill="none" aria-hidden="true">
      <rect x="6" y="8" width="84" height="48" rx="3" stroke="#22c55e" strokeWidth="1.2" fill="none" />
      <line x1="6" y1="18" x2="90" y2="18" stroke="#22c55e" strokeWidth="1" opacity="0.6" />
      {[12, 16, 20].map((cx) => <circle key={cx} cx={cx} cy="13" r="1.2" fill="#22c55e" opacity="0.7" />)}
      <rect x="28" y="10" width="40" height="6" rx="1" stroke="#22c55e" strokeWidth="0.8" fill="none" opacity="0.5" />
      <g opacity="0.8">
        <rect x="12" y="24" width="36" height="26" stroke="#22c55e" strokeWidth="0.8" fill="none" />
        <path d="M12 38 Q24 30 30 38 T48 40" stroke="#22c55e" strokeWidth="0.8" fill="none" />
      </g>
      <rect x="52" y="24" width="32" height="8" stroke="#22c55e" strokeWidth="0.8" fill="none" opacity="0.6" />
      <rect x="52" y="36" width="32" height="4" fill="#22c55e" opacity="0.25" />
      <rect x="52" y="44" width="20" height="4" fill="#22c55e" opacity="0.15" />
    </svg>
  );
}

export function PhoneGlyph() {
  return (
    <svg width="40" height="72" viewBox="0 0 40 72" fill="none" aria-hidden="true">
      <rect x="4" y="4" width="32" height="64" rx="5" stroke="#22c55e" strokeWidth="1.2" fill="none" />
      <rect x="15" y="7" width="10" height="2" rx="1" fill="#22c55e" opacity="0.5" />
      <rect x="8" y="14" width="24" height="44" stroke="#22c55e" strokeWidth="0.8" fill="none" opacity="0.6" />
      <circle cx="20" cy="36" r="5" stroke="#22c55e" strokeWidth="1" fill="none" />
      <circle cx="20" cy="36" r="1.3" fill="#22c55e" />
      <line x1="20" y1="28" x2="20" y2="44" stroke="#22c55e" strokeWidth="0.6" opacity="0.5" />
      <line x1="12" y1="36" x2="28" y2="36" stroke="#22c55e" strokeWidth="0.6" opacity="0.5" />
      <rect x="11" y="61" width="18" height="3" fill="#22c55e" opacity="0.3" />
    </svg>
  );
}
